import {Injectable} from '@angular/core';
import {Location} from "@angular/common";
import {Observable, Subject} from "rxjs";

import {CordovaService} from "../cordova/cordova.service";
import {MP_RESULT} from "../../components/msg-popup/msg-popup.component";
import {LayoutMgrService} from "../layout-mgr/layout-mgr.service";

@Injectable({
  providedIn: 'root'
})
export class BackBtnService {

  private backBtn$ = new Subject<void>();
  public get backBtn(): Observable<void> {
    return this.backBtn$.asObservable();
  }

  constructor(
    private location: Location,
    private cordova: CordovaService,
    private lm: LayoutMgrService,
  ) {
    // console.warn('BackBtnService::constructor');

    cordova.deviceready.subscribe(() => {
      document.addEventListener('backbutton', () => {
        // console.warn('BackBtnService:: backbutton');
        this.backBtn$.next();

        this.ProcessBack();
      });
    });
  }

  public ProcessBack(): void {
    if (this.lm.showMenu) {
      this.lm.showMenu = false;
    } else if (this.lm.showBookmark) {
      this.lm.showBookmark = false;
    } else if (this.lm.showHelp) {
      this.lm.showHelp = false;
    } else if (this.lm.showExampleHelp) {
      this.lm.showExampleHelp = false;
    } else if (this.lm.showMsgPopup) {
      this.lm.onClickMsgBtn(MP_RESULT.CANCEL);
    } else if (this.lm.showPitch) {
      this.lm.ClosePitchPopup();
    } else if (this.lm.youtubePopup$) {
      this.lm.CloseYoutubePopup();
    } else {
      this.defaultBack();
    }
  }

  public defaultBack(): void {
    this.location.back();
  }
}
